import React, {useCallback, useEffect, useState} from 'react';
import {PageHeader, PageWidget} from "../../components/contentComponents";
import {
    loadTraderStrategies, updatePagination as updateTraderStrategiesPagination, openEditDialog, closeEditDialog,
    updateTraderStrategy, loadAssets, deleteTraderStrategy
} from "./traderStrategiesSlice";
import {useDispatch, useSelector} from "react-redux";
import {Icon} from "@iconify/react";
import {Button, Divider, Popconfirm, Table} from "antd";
import TableWrapper from "../../components/antdWrappers/TableWrapper";
import {loadStrategies, updatePagination } from "./strategiesSlice";
import TraderStrategyDialog from "./TraderStrategyDialog";

const PortfolioTradingSettingsPage = () => {
    const dispatch = useDispatch();

    const {
        loading,
        pagination,
        strategies
    } = useSelector(state => state.strategies);

    useEffect(() => {
        dispatch(loadStrategies({pagination}));
        dispatch(loadAssets())
    }, [dispatch, pagination.current, pagination.pageSize]);

    const {
        loading: traderStrategiesLoading,
        pagination: traderStrategiesPagination,
        traderStrategies,
        visibleDialog,
        editedTraderStrategy,
        assets
    } = useSelector(state => state.traderStrategies);

    useEffect(() => {
        dispatch(loadTraderStrategies({traderStrategiesPagination}));
    }, [dispatch, traderStrategiesPagination.current, traderStrategiesPagination.pageSize]);


    const strategiesColumns = [
        {
            title:
                <React.Fragment>
                    <div>Код</div>
                </React.Fragment>
            , dataIndex: 'code'
        }
        ,{
            title:
                <React.Fragment>
                    <div>Наименование</div>
                </React.Fragment>
            , dataIndex: 'name'
        }
        ,{
            title:
                <React.Fragment>
                    <div>Описание</div>
                </React.Fragment>
            , dataIndex: 'description'
        }
        ,{
            title:
                <React.Fragment>
                    <div>Доходность</div>
                </React.Fragment>
        }
        ,{
            title: <Icon fontSize={20} icon='lucide:more-horizontal'/>
            , key: 'action'
            , align: 'center'
            , width: 80
            , render: ( record) => {
                // const {code} = record;
                return (
                    <div className='ip-transactions'>
                        <Button type='link'
                                onClick={() => openDialog({
                                    strategy: record,
                                    isActive: true
                                })}
                                icon={<Icon icon="mdi:plus-circle-outline" />}
                        />
                    </div>
                );
            },
        }
    ];

    const traderStrategiesColumns = [
        {
            title: 'Стратегия'
            , key: 'strategy'
            , render: (record) => record.strategy?.code || 'Нет данных'
        }
        ,{
            title: 'Счет'
            , dataIndex: 'asset'
            ,render: (asset = {}) => {
                const {id, name} = asset;
                return name;
            }
        }
        ,{
            title:
                <React.Fragment>
                    <div>Активный</div>
                </React.Fragment>
            , dataIndex: 'isActive'
            , render: (isActive) => isActive ? 'Да' : 'Нет'
        }
        ,{
            title:
                <React.Fragment>
                    <div>Тек.доходность</div>
                </React.Fragment>
        }
        ,{
            title: <Icon fontSize={20} icon='lucide:more-horizontal'/>
            , key: 'action'
            , align: 'center'
            , width: 80
            , render: (record) => {
                const {strategy = {}, id} = record;
                const {code} = strategy;
                return (
                    <div className='ip-transactions'>
                        <Button type='link' onClick={() => openDialog(record)}>
                            <Icon fontSize={14} icon='material-symbols:edit-outline'/>
                        </Button>
                        <Divider type="vertical"/>
                        <Popconfirm
                            title={`Вы уверены что хотите удалить настройку для ${code}?`}
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => dispatch(deleteTraderStrategy({id}))}
                        >

                            <Button type='link' >
                                <Icon fontSize={14} icon='material-symbols:delete-outline'/>
                            </Button>
                        </Popconfirm>
                    </div>
                );
            },
        }
    ];

    const openDialog = (traderStrategy = {}) => {
        dispatch(openEditDialog(traderStrategy));
    }

    const handleDialogResult = (result, traderStrategy = {}) => {
        if(result)
            dispatch(updateTraderStrategy(traderStrategy));
        dispatch(closeEditDialog());
    }



    return(
        <>
            <PageHeader caption='Алгоритмическая торговля' />
            <PageWidget caption='Стратегии'>
                <TableWrapper>
                    <Table
                        columns={strategiesColumns}
                        rowKey='code'
                        dataSource={strategies}
                        loading={loading}
                        pagination={pagination}
                        size="small"
                        bordered
                        onChange={( pagination, tableFilters, sorter) => {
                            const {field, order} = sorter;
                            const sort = { field, order };
                            dispatch(updatePagination(pagination));
                        }} />
                </TableWrapper>
            </PageWidget>
            <PageWidget caption='Подключенные стратегии'>
                <TableWrapper>
                    <Table
                        columns={traderStrategiesColumns}
                        rowKey='id'
                        dataSource={traderStrategies}
                        loading={traderStrategiesLoading}
                        pagination={traderStrategiesPagination}
                        size="small"
                        bordered
                        onChange={( pagination, tableFilters, sorter) => {
                            const {field, order} = sorter;
                            const sort = { field, order };
                            dispatch(updateTraderStrategiesPagination(pagination));
                        }}
                    />
                </TableWrapper>
            </PageWidget>
            <TraderStrategyDialog
                visible={visibleDialog}
                data={editedTraderStrategy}
                strategies={strategies}
                assets={assets}
                dialogHandler={handleDialogResult}
            />
        </>
    )
}

export default PortfolioTradingSettingsPage;
